import type * as React from 'react';

import { fieldControlVariants } from '@/components/ui/input';
import { cn } from '@/lib/utils';

/**
 * The correction note staff owe a guest was previously a bare `<textarea>` with
 * hand-written classes, which is why it focused differently from every field
 * beside it. It now borrows the shared control styling and overrides only what
 * a multi-line field genuinely needs: no fixed height, vertical resize only —
 * horizontal resize would let a user drag it out of its dialog.
 */
function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        fieldControlVariants(),
        'h-auto min-h-16 resize-y px-3 py-2 leading-relaxed',
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
